/** Site-wide SEO defaults — override base URL via REACT_APP_SITE_URL in production. */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://andreafagioli.com'
).replace(/\/$/, '');

export const SITE_NAME = 'Andrea Fagioli';
export const SITE_TITLE = 'Andrea Fagioli — Creative Direction, 3D & Web';
export const SITE_TAGLINE =
  'Creative direction, 3D production, information design and web development.';
export const DEFAULT_DESCRIPTION =
  'Portfolio of Andrea Fagioli: creative direction, hybrid AI × 3D production, information design and web development for brands and studios across Europe.';

export const DEFAULT_OG_IMAGE = '/logo-af.png';
export const LOCALE = 'en_US';
export const TWITTER_CARD = 'summary_large_image';

export function absoluteUrl(path) {
  if (!path || path === '/') return `${SITE_URL}/`;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
